<template>
  <div id="role">
   <div class="btnBoxs">
    <div class="search">
      <div>
      <span style="font-size: 0.75rem;">匹配模式:</span>
      <el-select v-model="pattern" filterable placeholder="请选择" style="width:300px;" size='mini'>
        <el-option v-for="(item,index) in patternAll" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div style="margin-left:60px">
      <span style="font-size: 0.75rem;">关键字:</span>
      <el-input v-model="keywords" autocomplete="off" style="width: 200px;" size='mini'>
      </el-input>
    </div>
    <div class="btn">
    <div>
      <el-button type="primary" size='mini'  icon="el-icon-search" @click="pagefeed(1)">搜 索</el-button>
      <el-button  size='mini'  icon="el-icon-circle-close" @click=" keywords = '' ">清 空</el-button>
    </div>
      </div>
    </div>
    </div>
    <el-button @click="addClick()" type="primary" icon="el-icon-edit" size="mini">添加</el-button>
    <!-- <el-button @click="delentClick()" type="danger" icon="el-icon-delete" size="small">删 除</el-button> -->
    <el-table :data="tableData" border style="width: 100%" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column prop="GZL_DEPARTMENT_id_PK" label="ID" align="center">
      </el-table-column>
      <el-table-column prop="name" label="部门名称" align="center">
      </el-table-column>
      <el-table-column prop="companyid_FK__name" label="公司名称" align="center">
      </el-table-column>
      <el-table-column label="操作" width="300" align="center">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="primary" icon="el-icon-edit" size="small">修改</el-button>
          <el-button @click="delentClick(scope.row)" type="danger" icon="el-icon-delete" size="small">删 除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag  :title="title" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
        <el-form-item label="部门名称" style="display: flex;">
          <el-input v-model="sizeForm.name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="Destroy()">取 消</el-button>
          <el-button type="primary" @click="confirm()" v-if="confirmTF">确 定</el-button>
          <el-button type="primary" @click="confirmON()" v-else>确 定</el-button>
        </el-form-item>


      </el-form>
    </el-dialog>
    <div class="block">
      <!-- 分页 -->
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout="total, prev, pager, next, slot, jumper" :total="currentPage4">
        <!-- <span style="width: 100px;">
          <el-input v-model.number="currentPage" @input="handlePageSize" size='mini'></el-input>条/页
        </span> -->
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    department
  } from '../../static/API/API.js'
  export default {
    data() {
      return {
        sizeForm: {
          name: '',
          GZL_DEPARTMENT_id_PK:'',
          companyid_FK__name:''
        },
        tableData: [],
        // 分页
        currentPage4: 0,
        currentPage1: 1,
        currentPage: 10,
        pageSize: 1,
        keywords: '',
        pattern: '',
        patternAll: [{
          value: 'name',
          label: '部门名称'
        },],
        dialogVisible: false,
        confirmTF: false,
        value: '',
        loading:false,
        TableHeight:490,
        title:''
      }
    },
    methods: {
      //添加确定
      confirm() {
        let params = new URLSearchParams()
        params.append('ope_type', 'create')
        params.append('name', this.sizeForm.name)
        this.$axios.post(department,params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
          this.Destroy()
        })
        console.log(this.sizeForm)
        this.dialogVisible = false

      },
      // 修改确定
      confirmON() {
        console.log( this.sizeForm);
        let params = new URLSearchParams()
        params.append('ope_type', 'update')
        params.append('department_id', this.sizeForm.GZL_DEPARTMENT_id_PK)
        params.append('name', this.sizeForm.name)
        this.$axios.post(department,params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
          this.Destroy()
        })
        console.log(this.sizeForm)
        this.dialogVisible = false

      },
      /* 添加角色*/
      addClick() {
        this.dialogVisible = true
        this.confirmTF = true
        this.title = '添加部门'
        this.sizeForm = {
          name: '',
          department_id:'',
          name:''
        }
      },
      // 修改角色信息
      handleClick(row) {
        this.title = '修改部门'
        this.confirmTF = false
        this.sizeForm = row
        this.dialogVisible = true
      },
      // 删除
      delentClick(row) {
        let params = new URLSearchParams()
        params.append('ope_type', 'delete')
        params.append('department_id', row.GZL_DEPARTMENT_id_PK)
        this.$axios.post(department,params).then(res => {
          if(res.data =='修改成功!'){
            this.$message({
              message:'删除成功！',
              type: 'success',
              duration: 1000,
            showClose: true,
            })
            this.pagefeed()
          }else{
            this.$message({
              message:res.data,
              type: 'success',
              duration: 1000,
            showClose: true,
            })
            this.pagefeed()
          }
        })
      },
      pagefeed(e) {
        this.loading = true
        let params = new URLSearchParams()
       params.append('keyword', this.keywords)
       params.append('page_size', this.currentPage)
       if(e){
         params.append('page_number', 1)
       }else{
         params.append('page_number', this.currentPage1)
       }
        this.$axios.get(department,{params}).then(res => {
          this.tableData = res.data['result']
          this.currentPage4 = Number(res.data['page_total'])
          setTimeout(()=>{
            this.loading = false
          },300)
        })
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed()
      },
      // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
      handlePageSize() {
        if (!this.pageSize) {
          this.pageSize = 7
          // this.pagefeed()
        } else {
          // this.pagefeed()
        }
      },
      Destroy() {
        var _this = this
        _this.tableData = []
        _this.dialogVisible = false
        this.pagefeed()
      },
      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 262;//数值"140"根据需要调整
    })
      },
    },
    mounted() {
      this.pagefeed()
      this.getHeight()
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    // beforeDestroy() {
    //   this.Destroy()
    // }
  }
</script>

<style scoped>

  .block {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-form-item__label {
    width: 8.75rem !important;
  }

  .select {
    width: 25rem !important;
  }

  .el-select-dropdown {
    max-width: 2.5rem;
    width: 25rem;
    transform-origin: center top;
    z-index: 2009;
    position: absolute;
    top: 28.5625rem;
    left: 57.25rem
  }

  .el-select-dropdown__item {
    overflow: visible;
  }

  .el-popper[x-placement^=top] {
    margin-bottom: 0.75rem;
    width: 25rem !important;
    background-color: red;
  }
  .btnBoxs{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .search{
    display: flex;
    align-items: center;
  }
  .btn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/role.vue